import React, { createContext, useContext, useState } from 'react';

interface Comment {
  id: string;
  userId: string;
  userName: string;
  content: string;
  createdAt: Date;
  likes: string[];
  replies: Comment[];
}

interface SharedGoal {
  id: string;
  userId: string;
  userName: string;
  userAvatar?: string;
  goalTitle: string;
  goalDescription: string;
  progress: {
    current: number;
    target: number;
    percent: number;
  };
  type: 'focus' | 'task';
  period: string;
  sharedAt: Date;
  message: string;
  supporters: string[];
  comments: Comment[];
}

interface SharedGoalsContextType {
  sharedGoals: SharedGoal[];
  addSharedGoal: (goal: SharedGoal) => void;
}

const SharedGoalsContext = createContext<SharedGoalsContextType>({
  sharedGoals: [],
  addSharedGoal: () => {},
});

export function SharedGoalsProvider({ children }: { children: React.ReactNode }) {
  const [sharedGoals, setSharedGoals] = useState<SharedGoal[]>([]);

  const addSharedGoal = (goal: SharedGoal) => {
    setSharedGoals(prev => [goal, ...prev]);
  };

  return (
    <SharedGoalsContext.Provider value={{ sharedGoals, addSharedGoal }}>
      {children}
    </SharedGoalsContext.Provider>
  );
}

export const useSharedGoals = () => useContext(SharedGoalsContext); 